// extracted by mini-css-extract-plugin
export default {"wrapper":"Select_wrapper__jd9H8","error":"Select_error__JRT9x"};